module.exports = __webpack_public_path__ + "img/activated.15b430dd.png";